module.exports = __webpack_public_path__ + "img/bowling-pins.a1ec4ef9.svg";